import Image from "next/image";
import sportsbookLogo from "../../../public/images/sportsbookLogo.svg";

const SportsBookLogo = () => (
  <Image src={sportsbookLogo} width={196} height={30} alt="SportsBookLogo" />
);

export default SportsBookLogo;
